import React from "react";
import { default as WSwitch } from "@mui/material/Switch";

function Switch(props) {
  return <WSwitch {...props} />;
}

export default Switch;
